import {
  collection,
  doc,
  QueryDocumentSnapshot,
  setDoc,
  Timestamp,
  updateDoc,
} from 'firebase/firestore';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { firestore } from 'services';
import { Button, Input } from 'shared/Components';
import { FlexContainer, Text } from 'shared/Typhography';
import styled from 'styled-components';

import { PayoutRequest } from '../PayoutRequestsScreen';

interface ApproveRequestModalProps {
  close: (refreshDoc: boolean) => void;
  payoutRequest: QueryDocumentSnapshot<PayoutRequest>;
  user: { id: string; name: string; profileImage: string };
}

const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-sizing: border-box;
`;

interface FormInputs {
  approvedAmount?: number;
  paymentMethod?: string;
}

export default function ApproveRequestModal({
  payoutRequest,
  close,
  user,
}: ApproveRequestModalProps) {
  const { handleSubmit, control } = useForm<FormInputs>();

  const onSubmit = handleSubmit(async (data: FormInputs) => {
    console.log(data);

    if (!data?.approvedAmount || !data?.paymentMethod) {
      toast.error('You have to fill all fields!');
      return;
    }

    try {
      const docRef = doc(firestore, `payoutRequests/${payoutRequest.id}`);

      await updateDoc(docRef, {
        updatedAt: Timestamp.now(),
        status: 'approved',
        approvedAmount: +data.approvedAmount,
        paymentMethod: data.paymentMethod,
      });

      const historyRef = collection(firestore, `payoutRequests/${payoutRequest.id}/history`);
      await setDoc(doc(historyRef), {
        actor: {
          id: user?.id,
          name: user?.name,
          profileImage: user?.profileImage,
        },
        createdAt: Timestamp.now(),
        updatedAttributes: ['status', 'approvedAmount', 'payoutMethod'],
        updates: [
          {
            attribute: 'status',
            previousValue: payoutRequest?.data().status,
            value: 'approved',
          },
          {
            attribute: 'approvedAmount',
            previousValue: payoutRequest?.data()?.approvedAmount,
            value: +data?.approvedAmount,
          },
          {
            attribute: 'payoutMethod',
            previousValue: payoutRequest?.data()?.paymentMethod,
            value: data?.paymentMethod,
          },
        ],
      });

      close(true);
    } catch (err) {
      toast.error('Something went wrong!');
      console.log(err);
    }
  });

  return (
    <ModalContainer>
      <FlexContainer flexDirection="column" gap="20px">
        <Text weight="bold">Payout Request approval</Text>

        <form
          style={{ marginTop: '50px' }}
          onSubmit={onSubmit}
          onKeyPress={(event) => {
            if (event.key == 'Enter') event.preventDefault();
          }}
        >
          <Input
            required
            label="Payout Method"
            placeholder="Enter Payout Method"
            name="paymentMethod"
            type="text"
            control={control}
            width="100%"
            marginBottom={20}
            marginRight={30}
            margin="0 auto 40px"
          />
          <Input
            required
            label="Approved Amount"
            placeholder="Enter approved amount"
            name="approvedAmount"
            type="number"
            control={control}
            width="100%"
            marginBottom={20}
            marginRight={30}
            margin="0 auto 40px"
          />
          <FlexContainer justifyContent="flex-end" gap="20px">
            <Button
              style={{ padding: '5px' }}
              width="max-content"
              variant="danger"
              onClick={() => close(false)}
            >
              Close
            </Button>
            <Button style={{ padding: '5px' }} width="max-content" type="submit">
              Submit
            </Button>
          </FlexContainer>
        </form>
      </FlexContainer>
    </ModalContainer>
  );
}
